import { appState } from './store.js';
import { router, navigateTo } from './router.js';
import { firebaseAuth } from './firebase.js';
import { showToast } from './components/toast.js';
import { escapeHtml } from './utils/security.js';

// Hide loading screen
export function hideLoadingScreen() {
  const loadingScreen = document.getElementById('loading-screen');
  if (loadingScreen) {
    loadingScreen.classList.add('fade-out');
    setTimeout(() => {
      loadingScreen.remove();
    }, 300);
  }
}

// Show loading screen
export function showLoading() {
  let loadingScreen = document.getElementById('loading-screen');
  if (!loadingScreen) {
    loadingScreen = document.createElement('div');
    loadingScreen.id = 'loading-screen';
    loadingScreen.className = 'loading-screen';
    loadingScreen.innerHTML = `
      <div class="loading-content">
        <div class="loading-logo">📚</div>
        <div class="loader"></div>
        <p>Đang tải...</p>
      </div>
    `;
    document.getElementById('app').appendChild(loadingScreen);
  }
}

// Render main layout with navbar
export function renderLayout(content, options = {}) {
  const app = document.getElementById('app');
  const { hideNav = false, isAdmin = false } = options;

  const adminContentStyle = isAdmin ? 'margin-left: 260px; padding: 24px; min-height: 100vh;' : '';

  app.innerHTML = `
    ${!hideNav ? renderNavbar(isAdmin) : ''}
    <main class="main-content ${isAdmin ? 'content-with-sidebar' : ''}" style="${adminContentStyle}">
      ${content}
    </main>
    ${!hideNav && !isAdmin ? renderBottomNav() : ''}
    <div id="toast-container" class="toast-container"></div>
    <div id="modal-container"></div>
  `;
}

// Render navbar for students
function renderNavbar(isAdmin) {
  if (isAdmin) {
    return renderAdminSidebar();
  }

  const userData = appState.getState().userData || {};

  return `
    <nav class="navbar">
      <a href="#/dashboard" class="navbar-brand">
        <span>📚</span>
        <span>English Reviewer</span>
      </a>
      
      <ul class="navbar-nav">
        <li><a href="#/dashboard" class="nav-link ${isActive('/dashboard')}">🏠 Trang chủ</a></li>
        <li><a href="#/flashcards" class="nav-link ${isActive('/flashcards')}">🃏 Flashcard</a></li>
        <li><a href="#/quiz" class="nav-link ${isActive('/quiz')}">❓ Quiz</a></li>
        <li><a href="#/lessons" class="nav-link ${isActive('/lessons')}">📖 Bài học</a></li>
        <li><a href="#/vocabulary" class="nav-link ${isActive('/vocabulary')}">📝 Từ vựng</a></li>
        <li><a href="#/leaderboard" class="nav-link ${isActive('/leaderboard')}">🏆 Bảng xếp hạng</a></li>
      </ul>
      
      <div class="navbar-end">
        <div class="streak-badge" title="Chuỗi ngày học">
          <span class="streak-icon">🔥</span>
          <span>${userData.streak || 0}</span>
        </div>
        <a href="#/profile" class="avatar" title="${escapeHtml(userData.name) || 'Profile'}">
          ${escapeHtml((userData.name || 'U').charAt(0).toUpperCase())}
        </a>
      </div>
    </nav>
  `;
}

// Check if route is active
function isActive(path) {
  const currentPath = router.getCurrentPath();
  return currentPath === path || currentPath.startsWith(path + '/') ? 'active' : '';
}

// Render bottom navigation for mobile
function renderBottomNav() {
  return `
    <nav class="bottom-nav">
      <ul class="bottom-nav-items">
        <li>
          <a href="#/dashboard" class="bottom-nav-item ${isActive('/dashboard')}">
            <span class="icon">🏠</span>
            <span>Trang chủ</span>
          </a>
        </li>
        <li>
          <a href="#/flashcards" class="bottom-nav-item ${isActive('/flashcards')}">
            <span class="icon">🃏</span>
            <span>Flashcard</span>
          </a>
        </li>
        <li>
          <a href="#/quiz" class="bottom-nav-item ${isActive('/quiz')}">
            <span class="icon">❓</span>
            <span>Quiz</span>
          </a>
        </li>
        <li>
          <a href="#/leaderboard" class="bottom-nav-item ${isActive('/leaderboard')}">
            <span class="icon">🏆</span>
            <span>Xếp hạng</span>
          </a>
        </li>
        <li>
          <a href="#/profile" class="bottom-nav-item ${isActive('/profile')}">
            <span class="icon">👤</span>
            <span>Tôi</span>
          </a>
        </li>
      </ul>
    </nav>
  `;
}

// Render admin sidebar
function renderAdminSidebar() {
  return `
    <aside class="sidebar">
      <div class="sidebar-header">
        <a href="#/admin" class="navbar-brand">
          <span>📚</span>
          <span>Admin Panel</span>
        </a>
      </div>
      
      <nav class="sidebar-nav">
        <div class="sidebar-section-title">Quản lý</div>
        <a href="#/admin/dashboard" class="sidebar-link ${isActive('/admin/dashboard') || isActive('/admin')}">
          📊 Dashboard
        </a>
        <a href="#/admin/students" class="sidebar-link ${isActive('/admin/students')}">
          👥 Học sinh
        </a>
        <a href="#/admin/content" class="sidebar-link ${isActive('/admin/content')}">
          📝 Nội dung
        </a>
        <a href="#/admin/assignments" class="sidebar-link ${isActive('/admin/assignments')}">
          📅 Giao bài
        </a>
        <a href="#/admin/settings" class="sidebar-link ${isActive('/admin/settings')}">
          ⚙️ Cài đặt SRS
        </a>
        
        <div class="sidebar-section-title">Tài khoản</div>
        <a href="#/dashboard" class="sidebar-link">
          🏠 Về trang học sinh
        </a>
        <button onclick="window.handleLogout()" class="sidebar-link" style="width: 100%; text-align: left; background: none; border: none; cursor: pointer;">
          🚪 Đăng xuất
        </button>
      </nav>
    </aside>
  `;
}

// Global logout handler
window.handleLogout = async () => {
  await firebaseAuth.signOut();
  navigateTo('/login');
  showToast('Đã đăng xuất', 'success');
};
